import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var Row = function (_a) {
    var children = _a.children;
    return (_jsx(React.Fragment, { children: _jsx("div", { className: 'row', children: children }) }));
};
